import { SortFilter } from '../../generated/maya.types';

const SORT_LABELS: Record<SortFilter, string> = {
  [SortFilter.NEWEST]: 'Sort by newest',
  [SortFilter.OLDEST]: 'Sort by oldest',
  [SortFilter.MOST_POPULAR]: 'Sort by most popular',
  [SortFilter.LESS_POPULAR]: 'Sort by less popular',
};

const sortFilterOptions = Object.values(SortFilter).map((value) => ({
  id: value,
  label: SORT_LABELS[value],
}));

export default sortFilterOptions;
